(function() {
    'use strict';

    angular
        .module('itxApp.common')
        .factory('rgpdService', rgpdService);

    rgpdService.$inject = [
        'ngDialog', 
        'ItxConfigurationSvc', 
        'DUTTI_CONS', 
        '$http', 
        'timestampSvc',
        'CountryService',
        '$q',
        'preCommonCmsConfigSvc'
    ];

    function rgpdService(
        ngDialog, 
        ItxConfigurationSvc, 
        DUTTI_CONS, 
        $http, 
        timestampSvc,
        CountryService,
        $q,
        preCommonCmsConfigSvc
    ) {

        var rgpdService = {
            getContentExcel: getContentExcel,
            openPopup: openPopup,
            openMemberGetMemberFeelWarningPopUp: openMemberGetMemberFeelWarningPopUp,
            openMemberGetMemberNewsletterWarningPopUp: openMemberGetMemberNewsletterWarningPopUp,
            isRgpdEnabled: isRgpdEnabled,
            openPolicy: openPolicy,
            openPurchaseCondition: openPurchaseCondition,
            checkStoreSpecialTax: checkStoreSpecialTax
        };
        return rgpdService;

        function openPopup(layer) {
            if(!layer){
                layer = 'layer_1';
            }
            // getContentCms();
            getContentExcel(layer)
            .then(function(data){
                openExcelPopup(data)
            })
        }

        function openPolicy() {
            window.open(inditex.getStaticResourceUrl('pdf/privacy_policy/' + inditex.iStoreId + '/privacy_policy' + inditex.iLangId + '.pdf'), '_blank');
        }

        function getContentExcel(layer) {

            var deferred = $q.defer();

            if(!layer){
                layer = 'layer_1';
            }



            var ts = timestampSvc.getTs();

            var url = inditex.iSt + 'pdf/privacy_policy/' + inditex.iStoreId + '/privacy_policy' + inditex.iLangId;
           
            var linksPolicy = {
                controller: url + '.pdf?' + ts + '#controller',
                use: url + '.pdf?' + ts + '#use',
                ground: url + '.pdf?' + ts + '#ground', 
                rights: url + '.pdf?' + ts + '#rights',
                policy: url + '.pdf?' + ts 
            };

            $http.get( inditex.iStaticContentUrl + 'configurations/rgpd-' + inditex.iStoreId + '.json' + '?' + ts )
                .then(function (res) {
                    var actualLangCode = DUTTI_CONS.i_languages[inditex.iLangId];
                    var dataRgpd = res.data[actualLangCode];
                    if(!dataRgpd){
                        dataRgpd = res.data['EN'];
                    }
                   
                    var data = {
                        common: dataRgpd.common,
                        layer: dataRgpd[layer],
                        links: linksPolicy
                    };
                    deferred.resolve(data);
                })
                .catch(function (error) {
                    console.error(error);
                    deferred.reject();
                });
                return deferred.promise;
        }

        function openExcelPopup(data) {
            ngDialog.open({
                template: 'popup-excel-rgpd.template.html',
                className: 'ma-dialog ngdialog-theme-plain  ma-modal-rgpd new-modal ma-modal-sm',
                showClose: true,
                data: data
            });
        }

        function openMemberGetMemberFeelWarningPopUp() {
            ngDialog.open({
                template: [
                    '<div class="ngdialog-content text-vertical-center">',
                    '    <div class="text-center p-50">',
                    '        <h3 class=" title-l ttu">{{ "dev.forms.messages.warning" | tCms }}</h3>',
                    '        <h5 class="title-m ttu">{{ "dev.forms.messages.noPromotionFeel" | tCms }}</h5>',
                    '    </div>',
                    '</div>'
                ].join(''),
                plain: true,
                className: 'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain',
                showClose: true
            });
        }

        function openMemberGetMemberNewsletterWarningPopUp() {
            ngDialog.open({
                template: [
                    '<div class="ngdialog-content text-vertical-center">',
                    '    <div class="text-center p-50">',
                    '        <h3 class="title-l ttu">{{ "dev.forms.messages.warning" | tCms }}</h3>',
                    '        <h5 class="title-m ttu">{{ "dev.forms.messages.noPromotionVIP" | tCms }}</h5>',
                    '    </div>',
                    '</div>'
                ].join(''),
                plain: true,
                className: 'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain',
                showClose: true
            });
        }

        function openPurchaseCondition() {
            window.open(inditex.getStaticResourceUrl('pdf/purchase_conditions/' + inditex.iStoreId + '/general_conditions' + inditex.iLangId + '.pdf'), '_blank');
        }

        function isRgpdEnabled() {
            return preCommonCmsConfigSvc.getProperty('rgpdEnabled');
        }

        function checkStoreSpecialTax() {
            return CountryService.is(DUTTI_CONS.stores.DuttiES) || CountryService.is(DUTTI_CONS.stores.DuttiIC);
        }

    }

})();
